<ng-template #emptySubject>
  <span>-</span>
</ng-template>

<div class="detail" [loading]="!loaded">
  <div style="display:flex">
    <h1>{{ 'ps.projectInfo' | brandTranslate }}</h1>
    <div class="actions">
      <a class="button" *ngIf="APP_BRAND.NAME === 'RSD' || APP_BRAND.NAME === 'SZ'" gmtAuth="manager_report"  uiSref="landing.managerReportProjects.detail" target="_blank" [uiParams]="{ projectKey: project.key }">Manažerský report akce</a>
    </div>
  </div>

  <div *ngIf="loaded">
    <div class="mt-30 mb-70 clearfix">
      <div class="edit" *ngIf="canEdit()">
        <a uiSref="symap.project.projectSettings.update" [uiParams]="{ goToPrevState: true }" class="button">Upravit údaje</a>
      </div>
      <div class="column-33">
        <label>Evidenční číslo</label>
        <div class="info">{{ project.isprofond }}</div>

        <label>{{ 'ps.projectName' | brandTranslate }}</label>
        <div class="info">{{ project.name }}</div>

        <div *ngIf="APP_BRAND.NAME === 'GMT'">
          <label>Smluvní název stavby</label>
          <div class="info">{{ project.contractName }}</div>
        </div>

        <ng-container *ngIf="projectFolder?.folderNumber">
          <label>Číslo spisu EPD</label>
          <div class="info">
            {{ projectFolder.folderNumber || '-'}}
          </div>
        </ng-container>

        <label>Kraj</label>
        <div class="info">{{ project.region }}</div>

        <div visibleByBrand="mpv">
          <label>Komunikace</label>
          <div class="info">{{ project.infrastructure }}</div>
        </div>

        <label>{{ 'ps.investor' | brandTranslate }}</label>

        <div visibleByBrand="mpv" class="info">{{ project.investor?.customerOrganizationalUnit | organizationalUnitName }}</div>
        <div visibleByBrand="maja" class="info">{{ project.investor | projectSubjectName }}</div>

        <div visibleByBrand="mpv">
          <label>{{ 'ps.unit' | brandTranslate }}</label>
          <div class="info">{{ project.investor?.customerOrganizationalUnit?.section }}</div>
        </div>

        <label>{{ 'ps.projectManager' | brandTranslate }}</label>
        <div class="info"><span *ngIf="project.manager; else emptySubject">{{ project.manager | username }}</span></div>

        <div visibleByBrand="mpv">
          <label>Typ akce</label>
          <div class="info">{{ project.type | projectTypeName }}</div>

          <label>Přiřazené vzory</label>
          <div class="info">{{ project.templatesOrganizationalUnit | templateOrganizationalUnitName}}</div>
        </div>
      </div>

      <div class="column-33">
        <label>{{ 'ps.propertyActivityProcessor' | brandTranslate }}</label>
        <div class="info"><span *ngIf="project.propertyActivityProcessor; else emptySubject">{{ project.propertyActivityProcessor | username }}</span></div>

        <label>Zpracovatel záb. elaborátu</label>
        <div class="info"><span *ngIf="project.landTakeDocumentationAuthor; else emptySubject">{{ project.landTakeDocumentationAuthor | projectSubjectName:true }}</span></div>

        <label>Projektant</label>
        <div class="info"><span *ngIf="project.designer; else emptySubject">{{ project.designer | projectSubjectName:true }}</span></div>

        <label>Stupeň</label>
        <div class="info">{{ project.phase }}</div>

        <label *ngIf="project.geodet">Geodet investora</label>
        <div class="info">{{ project.geodet | username }}</div>

        <label *ngIf="project.propertyActivityHead">Vedoucí MP činností</label>
        <div class="info">{{ project.propertyActivityHead | username }}</div>
      </div>

      <div class="column-33">
        <ng-container *ngIf="project.projectStartDate">
          <label>{{ 'ps.projectStartDate' | brandTranslate }}</label>
          <div class="info">{{ project.projectStartDate | date: 'mediumDate' }}</div>
        </ng-container>

        <ng-container *ngIf="project.state">
          <label>{{ 'ps.projectState' | brandTranslate }}</label>
          <div class="info">{{ project | projectState }}</div>
        </ng-container>

        <ng-container *ngIf="project.state === 'STARTED'">
          <label>Úplnost dat trvalého záboru</label>
          <div class="info">{{ project.readinessPermanentOccupations | readiness }}</div>

          <label>Úplnost dat dočasného záboru do 1 roku</label>
          <div class="info">{{ project.readinessTemporaryUnderOccupations | readiness }}</div>

          <label>Úplnost dat dočasného záboru nad 1 rok</label>
          <div class="info">{{ project.readinessTemporaryOverOccupations | readiness }}</div>

          <label>Úplnost dat věcných břemen</label>
          <div class="info">{{ project.readinessTemporaryEasements | readiness }}</div>
        </ng-container>
      </div>
    </div>
    <div class="mt-80">
      <gmt-navbar [tabs]="tabs" [isActiveTab]="isActiveTab">
        <div *ngIf="tab === 'notes'">
          <gmt-notes
            [noteList]="noteList"
            [editable]="true"
            [allowType]="false"
            [defaultData]="{projectInfo: true, systemType: false}"
            (updated)="onUpdateNoteList()"
          ></gmt-notes>
        </div>
        <div *ngIf="tab === 'land-take-documentation-notes'">
          <gmt-notes
            [noteList]="landTakeDocumentationNoteList"
            [editable]="canEdit()"
            [allowType]="false"
            [defaultData]="{landTakeDocumentation: true, systemType: false}"
            (updated)="onUpdateLandTakeDocumentationNoteList()"
          ></gmt-notes>
        </div>
        <div *ngIf="tab === 'documents'">
          <gmt-attachments
            [attachmentList]="attachmentList"
            [defaultData]="{projectInfo: true}"
            [allowType]="false"
            (updated)="onUpdateAttachmentList();"
          ></gmt-attachments>
        </div>
        <div *ngIf="tab === 'documents-epd'">
          <gmt-navbar [tabs]="documentTabs" [isActiveTab]="isActiveDocumentTab" (changed)="documentTab = $event">
            <div *ngIf="documentTab === 'documents-epd__documents'">
              <gmt-documents
                *ngIf="documentList && documentList.list"
                [documentList]="documentList"
                [folder]="projectFolder"
                [uploadDestination]="{ }"
                [showDocumentRelations]="true"
                (updated)="loadDocuments();"
              ></gmt-documents>
            </div>
            <div *ngIf="documentTab === 'documents-epd__components'">
              <gmt-components
                *ngIf="documentList && documentList.list"
                [documentList]="documentList"
                [folder]="projectFolder"
                (updated)="loadDocuments();"
              ></gmt-components>
            </div>
          </gmt-navbar>

        </div>
        <div *ngIf="tab === 'history'">
          <gmt-notes
            [noteList]="historyList"
            [editable]="false"
            type="history"
          ></gmt-notes>
        </div>
        <div *ngIf="tab === 'additional-info'">
          <gmt-labeled-block class="mb-20" label="Údaje k akci" [collapsed]="additionalInfoCollapsed['Údaje k akci']" (changed)="additionalInfoCollapsed['Údaje k akci'] = $event">
            <fieldset class="no-legend">
              <div class="column-100">
                <label class="label">Odlišný název akce pro generování do dokumentů:</label>
                <input type="text" [(ngModel)]="settings.contractName" (ngModelChange)="onAdditionalInfoChanged()" [attr.disabled]="authService.hasPermission('manage_properties') ? null : true" style="width: 400px"/>
              </div>
              <div visibleByBrand="mpv">
                <div class="column-100">
                  <label class="label wider">Informace pro platební příkaz v Helios pro výkup / věcné břemeno</label>
                </div>

                <div class="column-33">
                  <label class="label required">ISPROFOND / GLOBÁL akce</label>
                  <div class="input" gmtAuth="manage_properties">
                    <input type="text" [ngClass]="{ red: !validatePayment(settings.paymentEasement) }" [(ngModel)]="settings.paymentEasement" gmtInputNumber (ngModelChange)="onAdditionalInfoChanged();">
                  </div>
                  <div class="info" gmtAuthNot="manage_properties">
                    {{ settings.paymentEasement }}
                  </div>
                </div>

                <div class="column-33">
                  <label class="label required">Ev.č. akce (globál. položka JSIVV)</label>
                  <div class="input" gmtAuth="manage_properties">
                    <input type="text" [ngClass]="{ red: !validatePaymentInternalId(settings.paymentEasementInternalId) }" [(ngModel)]="settings.paymentEasementInternalId" gmtInputNumber (ngModelChange)="onAdditionalInfoChanged();">
                  </div>
                  <div class="info" gmtAuthNot="manage_properties">
                    {{ settings.paymentEasementInternalId }}
                  </div>
                </div>

                <div class="column-100">
                  <label class="label wider">Informace pro platební příkaz v Helios pro nájem</label>
                </div>

                <div class="column-33">
                  <label class="label required">ISPROFOND / GLOBÁL akce</label>
                  <div class="input" gmtAuth="manage_properties">
                    <input type="text" [ngClass]="{ red: !validatePayment(settings.paymentTemporaryOccupation) }" [(ngModel)]="settings.paymentTemporaryOccupation" gmtInputNumber (ngModelChange)="onAdditionalInfoChanged();">
                  </div>
                  <div class="info" gmtAuthNot="manage_properties">
                    {{ settings.paymentTemporaryOccupation }}
                  </div>
                </div>

                <div class="column-33">
                  <label class="label required">Ev.č. akce (globál. položka JSIVV)</label>
                  <div class="input" gmtAuth="manage_properties">
                    <input type="text" [ngClass]="{ red: !validatePaymentInternalId(settings.paymentTemporaryOccupationInternalId) }" [(ngModel)]="settings.paymentTemporaryOccupationInternalId" gmtInputNumber (ngModelChange)="onAdditionalInfoChanged();">
                  </div>
                  <div class="info" gmtAuthNot="manage_properties">
                    {{ settings.paymentTemporaryOccupationInternalId }}
                  </div>
                </div>
              </div>
            </fieldset>
          </gmt-labeled-block>

          <gmt-labeled-block visibleByBrand="!mpv" class="mb-20" label="Referenti kontroly věcné správnosti v Helios" [collapsed]="additionalInfoCollapsed['kvs']" (changed)="additionalInfoCollapsed['kvs'] = $event">
            <fieldset class="no-legend">
              <div class="column-100">
                <gmt-input label="Referent KVS č. 1">
                  <div class="input"><span *ngIf="project.manager; else emptySubject">{{ project.manager | username }}</span></div>
                </gmt-input>
                <gmt-input *ngFor="let item of [].constructor(9); let i = index" label="Referent KVS č. {{ i + 2 }}" >
                  <gmt-select
                    *ngIf="i==0 || settings.kvsReferents[i-1]"
                    (changed)="onKvsReferentsChanged(i, $event)"
                    [restangularService]="restangularSettings"
                    [filter]="kvsReferentsFilter[i]"
                    [reloadOptionsRegister]="reloadKvsReferentsRegister[i]"
                    [data]="settings.kvsReferents"
                    field="{{i}}"
                    resource="users/list"
                    [itemPipe]="userNamePipe"
                  ></gmt-select>
                  <div *ngIf="i && !settings.kvsReferents[i-1]" class="input">-</div>
                </gmt-input>
              </div>
            </fieldset>
          </gmt-labeled-block>

          <div [loading]="!loaded"></div>
          <div *ngIf="loaded">
            <gmt-labeled-block class="mb-20" *ngFor="let group of projectProperties" [label]="group.groupName || 'Nezařazeno'" [collapsed]="additionalInfoCollapsed[group.groupName]" (changed)="additionalInfoCollapsed[group.groupName] = $event">
              <fieldset class="no-legend" [ngClass]="{bordered: !authService.hasPermission('manage_properties')}">
                <div *ngFor="let item of group.items; let $index = index">
                  <div *ngIf="item.type" title="Proměnná šablony: {{item.templateVariable}}">
                    <gmt-input *ngIf="item.type==='USER_SELECT' && authService.hasPermission('manage_properties')" [label]="item.name">
                      <gmt-select
                        [restangularService]="restangularSettings"
                        [data]="usersTemp"
                        [field]="item.templateVariable"
                        resource="users/list"
                        selectTitle="Vyberte"
                        [itemPipe]="userNamePipe"
                        (changed)="onUserChanged($event.newValue, group, item.templateVariable);onAdditionalInfoChanged()"
                      ></gmt-select>
                    </gmt-input>
                    <gmt-input *ngIf="item.type === 'LONGTEXT'" [label]="item.name" [readonly]="!authService.hasPermission('manage_properties')">
                      <textarea [(ngModel)]="item.valueText" (ngModelChange)="onAdditionalInfoChanged()" gmtAuth="manage_properties"></textarea>
                      <pre gmtAuthNot="manage_properties">{{item.valueText}}</pre>
                    </gmt-input>
                    <gmt-input *ngIf="item.type === 'TEXT' && isVisible(group, item)" [label]="item.name" [readonly]="!authService.hasPermission('manage_properties')">
                      <input type="text" [(ngModel)]="item.valueText" (ngModelChange)="onAdditionalInfoChanged()" style="width:100%" gmtAuth="manage_properties"/>
                      <span gmtAuthNot="manage_properties">{{item.valueText}}</span>
                    </gmt-input>
                    <gmt-input *ngIf="item.type === 'DATE'" [label]="item.name" [readonly]="!authService.hasPermission('manage_properties')">
                      <input pick-a-date type="text" [(ngModel)]="item.valueDate" (ngModelChange)="onAdditionalInfoChanged()" gmtAuth="manage_properties"/>
                      <span gmtAuthNot="manage_properties">{{item.valueDate | date}}</span>
                    </gmt-input>
                    <gmt-input *ngIf="item.type === 'BOOLEAN'" [label]="item.name" [readonly]="!authService.hasPermission('manage_properties')">
                      <gmt-checkbox [gmtChecked]="item.valueBoolean" (click)="item.valueBoolean = !item.valueBoolean; onAdditionalInfoChanged()" gmtAuth="manage_properties"></gmt-checkbox>
                      <pre gmtAuthNot="manage_properties">{{item.valueBoolean ? 'ano' : 'ne' }}</pre>
                    </gmt-input>
                  </div>
                  <div *ngIf="!item.type" class="mb-10 pt-10" [ngClass]="{ 'bordered-top mt-10' : $index > 0 }"><b>{{translate(item.name)}}</b></div>
                </div>
              </fieldset>
            </gmt-labeled-block>
            <div gmtAuth="manage_properties">
              <gmt-button [clickAction]="saveProperties" [gmtDisabled]="!isValid()">Uložit</gmt-button>
            </div>
          </div>
        </div>
        <div *ngIf="tab === 'price-assessment'">
          <div *ngIf="!newPriceAssessment && authService.hasPermission('manage_properties')" class="mb-20"><gmt-button [clickAction]="onNewAssessment">Nový výměr</gmt-button></div>
          <fieldset *ngIf="newPriceAssessment">
            <legend>Nový výměr</legend>
            <div class="column-100">
              <label class="required">Rok</label><div class="input"><input type="text" [(ngModel)]="newPriceAssessment.year"/></div>
              <label class="required">Číslo výměru</label><div class="input"><input type="text" [(ngModel)]="newPriceAssessment.number"/></div>
              <label class="required">Ze dne</label><div class="input"><input type="text" pick-a-date [(ngModel)]="newPriceAssessment.date"/></div>
              <label>Text k uveřejnění do smlouvy</label><div class="input"><textarea class="w-350" [(ngModel)]="newPriceAssessment.description"></textarea></div>
            </div>
            <div class="column-100" *ngFor="let area of areas">
              <label>{{area.name}}</label><div class="input"><input type="text" [(ngModel)]="newPriceAssessment.price[area.id]" gmtInputNumber /></div><div class="info"><span class="unit">Kč/m<sup>2</sup></span></div>
            </div>
            <div class="mt-10 column-100"><gmt-button [clickAction]="onSaveAssessment" [gmtDisabled]="!isAssessmentValid(newPriceAssessment)">Uložit</gmt-button><gmt-button [clickAction]="onCancelNewAssessment" class="red">Zrušit</gmt-button></div>
          </fieldset>

          <div [loading]="!assessments" *ngIf="!newPriceAssessment">
            <gmt-labeled-block *ngFor="let assessment of assessments; index as i" [collapsed]="i != assessments.length - 1" [label]="assessment.year || '-'">
              <fieldset class="no-legend">
                <div class="column-100">
                  <label>Rok</label><div class="info">{{assessment.year}}</div>
                  <label>Číslo výměru</label><div class="info">{{assessment.number}}</div>
                  <label>Ze dne</label><div class="info">{{assessment.date | date}}</div>
                  <label>Text k uveřejnění do smlouvy</label>
                    <div class="input" *ngIf="i == assessments.length - 1 && authService.hasPermission('manage_properties')"><textarea class="w-350" [(ngModel)]="assessment.description"></textarea></div>
                    <div class="info" *ngIf="i != assessments.length - 1 || !authService.hasPermission('manage_properties')">{{assessment.description}}</div>
                </div>
                <ng-container *ngFor="let area of areas">
                  <div class="column-100" *ngIf="i == assessments.length - 1 || assessment.price[area.id]">
                    <label>{{area.name}}</label>
                    <div class="input" *ngIf="assessment.priceOrig && !assessment.priceOrig[area.id] && authService.hasPermission('manage_properties')"><input type="text" [(ngModel)]="assessment.price[area.id]" gmtInputNumber /></div>
                    <div class="info"><ng-container *ngIf="!assessment.priceOrig || assessment.priceOrig[area.id]">{{assessment.price[area.id]}} </ng-container><span class="unit">Kč/m<sup>2</sup></span></div>
                  </div>
                </ng-container>
                <div class="mt-10 column-100" *ngIf="i == assessments.length - 1 && authService.hasPermission('manage_properties')"><gmt-button [clickAction]="onUpdateAssessment" [gmtDisabled]="!isAssessmentValid(assessment)">Uložit</gmt-button></div>
              </fieldset>
            </gmt-labeled-block>
          </div>
        </div>
      </gmt-navbar>
    </div>
  </div>
  <help [helpId]="helpIds.PS_PROJECT_INFO" class="cm-help-page"></help>
</div>
